import { ReactNode } from 'react'
import { LinearTransform } from '@st/geom'
import { useLinearTransform } from '../use-linear-transform'

type Props = {
  children: ReactNode
  className?: string
  distance?: number
}
export function FloatingToolbar({ children, className, distance = 12 }: Props) {
  const transform = useLinearTransform()
  const inverseTransform = LinearTransform.invert(transform)

  return (
    <div
      className={className}
      style={{
        left: 0,
        top: 0,
        position: 'absolute',
        transformOrigin: 'bottom left',
        transform: `translateY(-100%) translateY(-${distance}px) ${LinearTransform.toCSS(
          inverseTransform
        )}`
      }}
      onMouseDown={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}
      onDoubleClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}
    >
      {children}
    </div>
  )
}
